module.exports = __webpack_public_path__ + "img/xzy05.cf68b48c.png";